import axiosInstanceClient from '../Common/Axios/axiosInstanceClient';
import API from '../Common/Endpoint/serviceConstrants';

export const callRegisterUserApi = async (payload) => {
  const { data = {} } = await axiosInstanceClient.post(API.register, payload);
  return data;
};
